
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { GoogleMap } from '@angular/google-maps';

export interface MapState {
  center: google.maps.LatLng;
  zoom: number;
  bounds: google.maps.LatLngBounds;
  sourceMapId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ChemicalCompareMapSyncService {
    private mapStateSubject = new BehaviorSubject<MapState | null>(null);
  mapState$ = this.mapStateSubject.asObservable();
  private showLegendSubject = new BehaviorSubject<boolean>(false);
  showLegends$ = this.showLegendSubject.asObservable();
  private mapRegistry = new Map<string, GoogleMap>();

  // Emits +1 or -1 for zoom in/out
  private zoomCommandSubject = new Subject<number>();
  zoomCommand$ = this.zoomCommandSubject.asObservable();

  // Emits when all maps should reset to their original bounds
  private resetSubject = new Subject<void>();
  reset$ = this.resetSubject.asObservable();

  registerMap(id: string, map: GoogleMap): void {
    this.mapRegistry.set(id, map);
  }

  unregisterMap(id: string): void {
    this.mapRegistry.delete(id);
  }

  clearRegistry(): void {
    this.mapRegistry.clear();
  }

  updateMapState(state: MapState): void {
    this.mapStateSubject.next(state);
    this.syncAllMapsDirectly(state);
  }

  private syncAllMapsDirectly(state: MapState): void {
    this.mapRegistry.forEach((map, id) => {
      if (id !== state.sourceMapId && map?.googleMap) {
        map.googleMap.setCenter(state.center);
        map.googleMap.setZoom(state.zoom);
      }
    });
  }

  getLatestState(): MapState | null {
    return this.mapStateSubject.value;
  }

  /** Called by parent to zoom all maps in (+1) or out (-1) */
  zoomAll(delta: number): void {
    this.zoomCommandSubject.next(delta);
  }

  /** Called by parent to reset all maps to their default bounds */
  resetAll(): void {
    this.mapStateSubject.next(null);
    this.resetSubject.next();
  }

  toggleLegends(): void {
    this.showLegendSubject.next(!this.showLegendSubject.value);
  }

  resetLegends(): void {
    this.showLegendSubject.next(false);
  }
}
